import {
  START_LOADING, START_LOADING_BLACK, END_LOADING
} from "../actions/loading_actions";

const initialState = {
  isLoading: false,
  black: false
};

export const loadingReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING: {
      return {...state, isLoading: true, black: false}
    }
    case START_LOADING_BLACK: {
      return {...state, isLoading: true, black: true}
    }
    case END_LOADING: {
      return {...state, isLoading: false, black: false}
    }
    default: return state;
  }
}
